module.exports = __webpack_public_path__ + "assets/img/banner-spy.e35b872a.webp";